import { ChangeDetectionStrategy, Component } from '@angular/core';
import { untranslatedString } from 'models/translated-string';
import { PopupMenuProvider, PopupMenuButton } from 'providers/popup-menu/popup-menu';

// The Menu Tests card's body on the Test UI Components page: a regular popup menu and a
// multiple-choice one, each with a selected and a disabled entry.
@Component({
  selector: 'cs-test-menus-card',
  host: { class: 'showcase-card-body' },
  template: `
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px; padding: 16px;">
      <cs-button small secondary (click)="showTestMenu($event)" icon="ellipsis-vertical" [label]="'Regular Menu' | untranslated" data-test="test-menu-button">
      </cs-button>

      <cs-button small secondary (click)="showCheckboxMenu($event)" icon="ellipsis-vertical" [label]="'Checkbox Menu' | untranslated"
        data-test="checkbox-menu-button">
      </cs-button>
    </div>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestMenusCardComponent {
  constructor(private popupMenuProvider: PopupMenuProvider) {}

  async showTestMenu(event: MouseEvent) {
    const buttons: PopupMenuButton[] = [
      {
        text: untranslatedString('Profile'),
        icon: 'person',
        handler: () => {
          console.log('Profile clicked');
        }
      },
      {
        text: untranslatedString('Settings'),
        icon: 'settings',
        selectState: true, // This item is selected
        handler: () => {
          console.log('Settings clicked');
        }
      },
      {
        text: untranslatedString('Notifications'),
        icon: 'notifications',
        handler: () => {
          console.log('Notifications clicked');
        }
      },
      {
        text: untranslatedString('Download'),
        icon: 'download',
        disabled: true, // This item is disabled
        handler: () => {
          console.log('Download clicked (disabled)');
        }
      },
      {
        text: untranslatedString('Help & Feedback'),
        icon: 'help',
        handler: () => {
          console.log('Help clicked');
        }
      },
      {
        text: untranslatedString('Sign Out'),
        icon: 'log-out',
        cssClass: 'danger',
        handler: () => {
          console.log('Sign out clicked');
        }
      }
    ];

    await this.popupMenuProvider.createMenu({
      buttons: buttons,
      targetFromElement: event.target as HTMLElement
    });
  }

  async showCheckboxMenu(event: MouseEvent) {
    const buttons: PopupMenuButton[] = [
      {
        text: untranslatedString('Show Notifications'),
        icon: 'notifications',
        selectState: true,
        handler: () => {
          console.log('Notifications toggled');
        }
      },
      {
        text: untranslatedString('Dark Mode'),
        icon: 'moon',
        selectState: false,
        handler: () => {
          console.log('Dark mode toggled');
        }
      },
      {
        text: untranslatedString('Auto-Save'),
        icon: 'save',
        selectState: true,
        handler: () => {
          console.log('Auto-save toggled');
        }
      },
      {
        text: untranslatedString('Show Hints'),
        icon: 'help-circle',
        selectState: false,
        handler: () => {
          console.log('Hints toggled');
        }
      },
      {
        text: untranslatedString('Beta Features'),
        icon: 'flask',
        selectState: false,
        disabled: true,
        handler: () => {
          console.log('Beta features toggled (disabled)');
        }
      }
    ];

    await this.popupMenuProvider.createMenu({
      buttons: buttons,
      selectMultiple: true, // Enable checkboxes
      targetFromElement: event.target as HTMLElement
    });
  }
}
